var _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPicture = function SvgPicture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.333 0C19.253 0 20 .746 20 1.667v16.666c0 .92-.746 1.667-1.667 1.667H1.667C.747 20 0 19.254 0 18.333V1.667C0 .747.746 0 1.667 0zm-5.19 10.47-5.111 6.133a.834.834 0 0 1-1.21.075l-.07-.075-2.326-2.79-2.76 3.31v1.21h16.667v-1.65c-.002 0-.003-.002-.005-.004l-.072-.076-5.113-6.134zm5.19-8.803H1.667L1.666 14.52l2.12-2.542a.833.833 0 0 1 1.21-.075l.07.075 2.325 2.79 5.113-6.135a.833.833 0 0 1 1.21-.074l.07.074 4.549 5.459V1.667z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 6.5,
    r: 1.5
  })));
};

export default SvgPicture;